import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createSailingCurrency = async (data) => {
  try {
    let res = await Api.post("/ship-currency", data);
    return res?.data;
  } catch (e) {
    let error = modifyError(e);

    return { error: error.message };
  }
};

export const getSailingCurrency = async (query) => {
  try {
    let res = await Api.get("/ship-currency", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getSailingDate = async (query) => {
  try {
    let res = await Api.get("/cruise-packages-sailing-dates", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getParentSailingDate = async (vessel_id) => {
  try {
    
    let res = await Api.get(
      "/daily-planner/parent/sailing-list/"+vessel_id
    );

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getParentSailingPage = async (vessel_id) => {
  try {
    
    let res = await Api.get(
      "/cruise-packages-sailing-dates/parent/sailing-list/"+vessel_id
    );

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const updateSailingCurrency = async (id, data) => {
  try {
    let res = await Api.patch("/ship-currency/" + id, data);

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
export const deleteSailingCurrency = async (id) => {
  try {
    let res = await Api.delete("/ship-currency/" + id);

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
